import { FC } from 'react';
import { useTranslation } from 'next-i18next';

import DetailsList from 'src/listing/components/DetailsList';
import Icon from 'src/common/components/Icon';
import getCategoryKeyById from 'src/common/utils/getCategoryKeyById';
import { usePreviewModeContext } from 'src/common/providers/PreviewModeProvider';
import styles from './BoatCategories.module.scss';

type BoatCategoriesProps = {
  primaryCategorySlug?: string;
  primaryCategoryId?: number | string;
  secondaryCategoryId?: number | string;
};

const BoatCategories: FC<BoatCategoriesProps> = ({
  primaryCategorySlug,
  primaryCategoryId,
  secondaryCategoryId,
}) => {
  const [t] = useTranslation(['boat-categories', 'admin-listing-preview']);
  const { previewMode } = usePreviewModeContext();

  const showPlaceholder = previewMode && !primaryCategoryId;
  if (!previewMode && !primaryCategoryId) {
    return null;
  }

  const getDescriptionCopy = () => {
    if (secondaryCategoryId) return t(getCategoryKeyById(secondaryCategoryId));
    if (showPlaceholder) return t('admin-listing-preview:category--placeholder');
    return '';
  };

  return (
    <div className={styles.root}>
      <Icon
        id={`listing/category-${primaryCategorySlug}`}
        className={styles.icon}
      />
      <DetailsList
        details={[{
          termIsProminent: !previewMode && !primaryCategoryId,
          term: showPlaceholder
            ? t('admin-listing-preview:category--title-placeholder')
            : t(getCategoryKeyById(primaryCategoryId)),
          description: getDescriptionCopy(),
        }]}
      />
    </div>
  );
};

export default BoatCategories;
